import { type ReactNode } from 'react'

interface InfoCardProps {
	title: string
	children: ReactNode
	icon?: ReactNode
	className?: string
}

/**
 * A minimal info card with optional icon, title, and content.
 * Clean design with accent border.
 *
 * @example
 * <InfoCard
 *   title="Card Title"
 *   icon={<svg>...</svg>}
 * >
 *   Card content goes here
 * </InfoCard>
 */
export function InfoCard({
	title,
	children,
	icon,
	className = '',
}: InfoCardProps) {
	return (
		<div
			className={`relative overflow-hidden border border-muted-foreground/30 p-4 sm:p-6 ${className}`}
		>
			<div className="mb-3 flex items-center gap-2 sm:mb-4 sm:gap-3">
				{icon && (
					<div className="flex h-8 w-8 items-center justify-center text-primary sm:h-10 sm:w-10">
						{icon}
					</div>
				)}
				<h3 className="font-display text-sm font-bold uppercase tracking-wider sm:text-base">
					{title}
				</h3>
			</div>
			<div className="text-xs leading-relaxed">{children}</div>
		</div>
	)
}
